import { useCallback } from 'react'

import { deleteCompany } from '@/features/domain/company'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

import { useTexts } from '../hooks/useTexts'

import { resetEditingState } from '@/atoms'
import { useController } from './useController'

export function useOnSubmit() {
  const toast = useNotification()
  const texts = useTexts()

  const dispatch = useAppDispatch()

  const {
    close,
    data: {
      company: { id: companyId },
    },
  } = useController()

  return useCallback(async () => {
    try {
      const result = await dispatch(deleteCompany(companyId))

      if (deleteCompany.rejected.match(result)) {
        throw new Error(result.payload?.message ?? 'Internal error')
      }

      const usersLeftWithoutCompany = result.payload ?? {}
      const usersLeftWithoutCompanyCount = Object.keys(usersLeftWithoutCompany).length

      if (usersLeftWithoutCompanyCount > 0) {
        toast.warning(texts.toast.usersLeftWithoutCompany(usersLeftWithoutCompanyCount), {
          autoClose: false,
        })
      }

      toast.success(texts.toast.success)

      resetEditingState()
      close?.()
    } catch (e) {
      toast.error(e.message)
    }
  }, [toast, close, dispatch, companyId, resetEditingState, texts])
}
